import { OrderStatus } from "@/models/order/helpers";
import { Order } from "@/models/order/order";
import { replaceLineItems } from "./actions";
import { setAllLineItems } from "./mutations";

export type OrderState = Order;

export type OrderContext = {
  state: OrderState;
  dispatch: (action: OrderActions, payload?: any) => any;
  commit: (mutation: OrderMutations, payload: any) => any;
};

export enum OrderMutations {
  SetLineItem = "setLineItem",
  SetStatus = "setStatus",
  SetShipping = "setShipping",
  SetBilling = "setBilling",
  SetPayment = "setPayment",
  SetContact = "setContact",
  SetOrder = "setOrder",
  ClearOrder = "clearOrder",
  SetAllLineItems = "setAllLineItems",
  SetCustomer = "setCustomer",
  SetNotes = "setNotes",
  SetOrderId = "setOrderId",
  EditLineItem = "editLineItem",
  ClearCustomer = "clearCustomer",
  SetCostDetails = "setCostDetails",
  ClearCreatedType = "clearCreatedType"
}

export enum OrderActions {
  AddLineItem = "addLineItem",
  AddOrderStatus = "addOrderStatus",
  AddShipping = "addShipping",
  AddBilling = "addBilling",
  AddPayment = "addPayment",
  AddContact = "addContact",
  AddOrder = "addOrder",
  AddNotes = "addNotes",
  AddOrderId = "addOrderId",
  ReplaceLineItems = "replaceLineItems",
  AssignCustomer = "assignCustomer",
  ClearOrder = "clearOrder",
  EditLineItem = "editLineItem",
  ClearCustomer = "clearCustomer",
  AddCostDetails = "addCostDetails",
  ClearCreatedType = "clearCreatedType"
}

export enum OrderGetters {
  GetOrder = "getOrder",
  GetOrderItems = "getOrderItems",
  GetAssignedCustomer = "getAssignedCustomer"
}
